import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import combineReducers from './reducers';
import { addOrderFromShipmentSaga, addOrderSaga } from './sagas/addOrderSaga';
import channelOrderItemOfOrderFromAmazonSaga from './sagas/channelOrderItemOfOrderFromAmazonSaga';
import { checkPostalCodeEditOrderSaga, checkPostalCodeSaga } from './sagas/checkPostalCodeSaga';
import { convertNameEditOrderSaga, convertNameSaga } from './sagas/convertNameSaga';
import deleteOrderFromEditOrderSaga from './sagas/deleteOrderFromEditOrderSaga';
import { editOrderSaga, restoreOrderSaga, updateOrderSaga } from './sagas/editOrderSaga';
import getListCountrySaga from './sagas/getListCountrySaga';
import getListCurrencySaga from './sagas/getListCurrencySaga';
import getlistItemNameSaga from './sagas/getListItemNameSaga';
import { getDetailShipmentSaga, getShipmentByIdSaga } from './sagas/getShipmentByIdSaga';
import rootSaga from './sagas/index';
import shipperInforSaga from './sagas/shipperInforSaga';
import getListChannelOrderSaga from './sagas/getListChannelOrderSaga'
import getListChannelShipmentSaga from './sagas/getListChannelShipmentSaga'

const sagaMiddleware = createSagaMiddleware()
const store = createStore(combineReducers, applyMiddleware(sagaMiddleware))

sagaMiddleware.run(rootSaga)
sagaMiddleware.run(addOrderSaga)
sagaMiddleware.run(addOrderFromShipmentSaga)
sagaMiddleware.run(checkPostalCodeSaga)
sagaMiddleware.run(checkPostalCodeEditOrderSaga)
sagaMiddleware.run(getlistItemNameSaga)
sagaMiddleware.run(getListCountrySaga)
sagaMiddleware.run(getListCurrencySaga)
sagaMiddleware.run(editOrderSaga)
sagaMiddleware.run(updateOrderSaga)
sagaMiddleware.run(getShipmentByIdSaga)
sagaMiddleware.run(getDetailShipmentSaga)
sagaMiddleware.run(deleteOrderFromEditOrderSaga)
sagaMiddleware.run(shipperInforSaga)
sagaMiddleware.run(restoreOrderSaga)
sagaMiddleware.run(convertNameSaga)
sagaMiddleware.run(convertNameEditOrderSaga)
sagaMiddleware.run(channelOrderItemOfOrderFromAmazonSaga)
sagaMiddleware.run(getListChannelOrderSaga)
sagaMiddleware.run(getListChannelShipmentSaga)

export default store



// WEBPACK FOOTER //
// ./src/store.js